import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useUserContext } from '@contexts/UserContext/UserProvider';
import Header from '@components/domain/Header';

const AuthRoute = ({ component: Component, ...rest }) => {
  const { token } = useUserContext();

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <>
            <Header />
            <Component {...props} />
          </>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default AuthRoute;
